import { LineItem } from '@repo/ui/src/types/lineItem';
import { publicRuntimeConfig } from '@utils/publicRuntimeConfig';
import round from 'lodash/round';
import { ProductProps } from '@repo/ui/src/types';

export const baseProduct = (
  {
    image,
    title,
    sku,
    originalPrice,
    quantity,
    category,
    discount,
    productUrl,
    description,
  }: LineItem | ProductProps,
  position: number,
) => ({
  category,
  description,
  discount: round(discount, 2),
  image_url: image,
  name: title,
  price: originalPrice,
  product_id: sku,
  url: `${publicRuntimeConfig.base}${productUrl}`,
  quantity,
  sku,
  variant: undefined,
  position,
});

export const basketLineInputToAnalytics = (lineItem: LineItem, position = 0) =>
  baseProduct(lineItem, position + 1);

export const productToAnalytics = (product: ProductProps, locale: string) => ({
  ...baseProduct(product, product.listPosition || 1),
  affiliation: 'website',
  locale,
  brand: 'Traeger',
  in_stock: product?.isOrderable,
  // Do we want this in every product / line item?
  currency: product?.currency,
});
